// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"6ab4d3a0","787":"c17879b6"}[chunkId] + ".chunk.js";
};